export const env = {
  production: true,
  ente: "ARTI",
  buildNumber: "stage-a4c8f8a0",
  portaleEnte: "https://arti.toscana.it/",
  oauth2Url: "https://trial.auth.regione.toscana.it/auth-trial",
  oauth2ClientId: "r_toscan__arti-arcodi-phylum",
  oauth2Scope: "",
  oauth2TimeoutFactor: "0.1",
  oauth2Logout:
    "https://trial.auth.regione.toscana.it/auth-trial/realms/rt/protocol/openid-connect/logout",
  oauth2LogoutMethod: "POST",
  API_ORGANIGRAMMA_ELENCO: "/protocollo/organigramma/organigrammaElenco",
  API_URL_BASE: "https://apistage.rete.toscana.it/Arti/C07/Arcodi/v2",
  DOCUMENTALE_API_URL_BASE:
    "https://apistage.rete.toscana.it/Arti/C07/Arcodi/v2",
  LINNEO_API_URL_BASE: "https://apistage.rete.toscana.it/Arti/C07/Arcodi/v2",
  DOCUMENTALE_REPERTORI_API_BASE_URL:
    "https://apistage.rete.toscana.it/Arti/C07/Arcodi/v2",
  DOCUMENTALE_ATTI_API_URL_BASE:
    "https://apistage.rete.toscana.it/Arti/C07/Arcodi/v2",
  DOCUMENTALE_NOTE_API_URL_BASE:
    "https://apistage.rete.toscana.it/Arti/C07/Arcodi/v2",
  API_UPLOAD_BASE: "https://apistage.rete.toscana.it/Arti/C07/Arcodi/v2",
  URL_DETTAGLIO_PARTENZE_GESCOR:
    "https://servizi-test.arti.toscana.it/gestione-corrispondenza/#/partenze/corrispondenza-partenza-digitale/",
  PROCEDIMENTO_RICERCA_URL: "/gempa/procedimento/",
  STATO_APPLICAZIONE_URL: "/documentale/fascicolo/stato-applicazione/",
  AUTH_BASE_PATH: "/cochise-public/authentication",
  APP_KEY: "documentale-fe-",
  APP_SECRET: "gs135365-b5ef-2f4e-9e31-fe0454312y245",
  API_DOCUMENTALE_ATTO: "/gestione-atti/",
  API_DOCUMENTALE_NOTA: "/note-liquidazione/",
  API_DOCUMENTALE_NOTA_EXT: "/note-liquidazione/ext",
  URL_SESSIONE_MODIFICA: "sessione-modifica/",
  URL_RICERCA_AVANZATA_ATTO: "ricerca/avanzata",
  URL_RICERCA_AVANZATA_NOTA: "ricerca/avanzata",
  URL_CONTATORE_ATTO: "contatore",
  NOTE_LIQUIDAZIONI_ESTRAIBILI_RESULTS_MAX: 10000,
  NOTE_LIQUIDAZIONI_ESTRAIBILI_ROWS_MAX: 1000,
  API_DOCUMENTALE_FASCICOLO: "/documentale/fascicolo/",
  API_DOCUMENTALE_REPERTORI: "/documentale/repertori/",
  API_DOCUMENTALE_SETTORE_FASCICOLI: "/documentale/settore-fascicoli/",
  URL_RICERCA_STORICO_CMU: "ricerca?filtro=",
  API_DOCUMENTALE_SERIE_DOCUMENTALI:
    "/documentale/fascicolo/serie-documentale/",
  API_DOCUMENTALE_SERIE_FASCICOLI: "/documentale/fascicolo/serie-fascicoli/",
  API_DOCUMENTALE_INSERISCI_RICHIESTA_INTERNE: "richiesta-interna/inserisci",
  API_DOCUMENTALE_RICERCA_RICHIESTE_INTERNE: "richiesta-interna/ricerca",
  API_DOCUMENTALE_TIPOLOGIE_DOCUMENTO_DEFAULT:
    "/documentale/fascicolo/tipologia-documento-default/",
  API_DOCUMENTALE_DETTAGLIO_RICHIESTA: "richiesta-interna/",
  API_DOCUMENTALE_STATISTICHE: "statistiche/",

  API_ORGANIGRAMMA_CMU: "/protocollo/organigramma/organigrammaRicerca/",
  API_ORGANO_GERARCHIA_CMU: "/protocollo/organigramma/organo/gerarchia?codice=",
  API_ORGANO_ALBERO_CMU: "/protocollo/organigramma/organo/gerarchia?radice=",
  API_ORGANO_ANAGRAFE_CF: "/protocollo/organigramma/organo/anagrafe?filtro=",
  API_AUTENTICA_UTENTE: "/autenticazione/utente/",
  API_UTENTI_PROFILO: "/autenticazione/utenti/?profilo=",
  API_DOCUMENTALE_PARTENZE: "/documentale/fascicolo/partenza/",
  URL_CONTROLLA_FIRMA: "/documentale/verifica-firma/controllaFirma/",
  URL_PREVIEW_DOC: "/documentale/verifica-firma/previewDocumento/",
  URL_RIMUOVI_FILE: "/documentale/repository/deleteDocumento/",
  URL_COLLEGAMENTI_UD:
    "/documentale/fascicolo/unita-documentaria/associazione/",
  URL_WRAPPER_COLLEGAMENTI_UD:
    "/documentale/fascicolo/unita-documentaria/associazione/wrapperDetails/",
  // URL_COLLEGAMENTI_FASCICOLO:
  //   "/documentale/fascicolo/associazione/",
  URL_CALCOLA_DIMENSIONE_DOCUMENTI: "/documentale/repository/document/size/",
  // URL_WRAPPER_COLLEGAMENTI_FASCICOLO:
  //   "/documentale/fascicolo/associazione/wrapperDetails/",

  URL_UTENTI_AUTORIZZ_PROFILO: "/autenticazione/utenti/?app=PHYLUM&profilo=",
  URL_CONTROLLA_MIMETYPE: "/documentale/verifica-firma/mimetype/",
  API_STATISTICHE_CORRISPONDENZA:
    "/documentale/corrispondenze/statistiche/dashboard/",
  URL_UPLOAD: "/documentale/repository/simpleupload/",
  URL_UNITA_DOCUMENTARIA: "/documentale/fascicolo/unita-documentaria/",
  URL_DOCUMENTO: "/documentale/fascicolo/documento/",
  // lista degli identificativi recapito che devono essere esclusi dai possibili
  // destinatari nella partenze
  API_DOWNLOAD_FILE: "/documentale/repository/download/",
  LISTA_RECAPITO_TO_EXCLUDE: "regionetoscana@postacert.toscana.it",
  LINNEO_RICERCA_TIPOLOGIA_FASCICOLO: "/linneo/tipologie-fascicolo/ricerca",
  LINNEO_RICERCA_TIPOLOGIA_IPER_FASCICOLO:
    "/linneo/tipologie-iper-fascicolo/ricerca",
  LINNEO_RICERCA_STORICO_TIPOLOGIA_FASCICOLO:
    "/linneo/tipologie-fascicolo/ricercaStorico",
  LINNEO_RICERCA_STORICO_TIPOLOGIA_IPER_FASCICOLO:
    "/linneo/tipologie-iper-fascicolo/ricercaStorico",
  LINNEO_RICERCA_STORICO_TIPOLOGIA_DOCUMENTO:
    "/linneo/tipologie-documento/ricercaStorico",
  LINNEO_RICERCA_TIPOLOGIA_FASCICOLO_BY_ID: "/linneo/tipologie-fascicolo/",
  LINNEO_RICERCA_TIPOLOGIA_DOCUMENTO_BY_ID: "/linneo/tipologie-documento/",
  LINNEO_TIPOLOGIA_FASCICOLO_ATTIVA_BY_CODICE:
    "/linneo/tipologie-fascicolo/byCodice",
  LINNEO_GET_TIPOLOGIe_DOCUMENTO_ASSOCIATE_BY_CODICE_TIPOLOGIA_FASCICOLO:
    "/tipologie-documento-associate",
  LINNEO_TIPOLOGIA_IPER_FASCICOLO_ATTIVA_BY_CODICE:
    "/linneo/tipologie-iper-fascicolo/byCodice",
  LINNEO_TIPOLOGIA_DOCUMENTO_BY_CODICE: "/linneo/tipologie-documento/byCodice",
  LINNEO_TIPOLOGIA_FASCICOLO: "/linneo/tipologie-fascicolo/",

  // LINNEO_CLASSIFICA: "/linneo/classifica/",
  LINNEO_CLASSIFICA_BY_CODICE_ESTESO: "/linneo/classifica/byCodiceExt",
  LINNEO_CLASSIFICA_RICERCA: "/linneo/classifica/ricerca?filtro=",
  LINNEO_CLASSIFICA_RICERCA_AVANZATA: "/linneo/classifica/ricerca",
  LINNEO_RICERCA_TIPOLOGIA_DOCUMENTO:
    "/linneo/tipologie-documento/ricerca?filtro=",
  LINNEO_RICERCA_CLASSIFICA_BY_SETTORE: "/linneo/classifica/ricerca",

  LINNEO_RICERCA_STORICO_REPERTORI_DOCUMENTI:
    "/linneo/repertori-documenti/ricercaStorico",

  LINNEO_RICERCA_STORICO_REPERTORI_FASCICOLI:
    "/linneo/repertori-fascicoli/ricercaStorico",

  LINNEO_RICERCA_STORICO_REPERTORI_IPER_FASCICOLI:
    "/linneo/repertori-iper-fascicoli/ricercaStorico",

  LINNEO_RICERCA_REPERTORIO_DOCUMENTO_ID: "/linneo/repertori-documenti/",

  LINNEO_RICERCA_REPERTORIO_DOCUMENTO_BY_CODICI_TIPOLOGIA:
    "/linneo/repertori-documenti/ricerca-per-codici-tipologie",

  LINNEO_RICERCA_REPERTORIO_FASCICOLO_ID: "/linneo/repertori-fascicoli/",

  LINNEO_RICERCA_REPERTORIO_IPER_FASCICOLO_ID:
    "/linneo/repertori-iper-fascicoli/",

  LINNEO_GET_TIPOLOGIA_REPERTORI_DOCUMENTI_BY_CODICE_TIPOLOGIA_DOCUMENTO:
    "/linneo/repertori-documenti/codice-tipologia-documento/",

  LINNEO_GET_TIPOLOGIA_REPERTORI_FASCICOLI_BY_CODICE_TIPOLOGIA_FASCICOLO:
    "/linneo/repertori-fascicoli/codice-tipologia-fascicolo/",
  LINNEO_GET_TIPOLOGIA_REPERTORI_IPER_FASCICOLI_BY_CODICE_TIPOLOGIA_IPER_FASCICOLO:
    "/linneo/repertori-iper-fascicoli/codice-tipologia-iper-fascicolo/",

  // attivita linneo

  LINNEO_RICERCA_AVANZATA_ATTIVITA: "/linneo/attivita/ricerca",

  LINNEO_ATTIVITA_ATTIVA_BY_CODICE: "/linneo/attivita/byCodice",

  LINNEO_CLASSIFICA_DETTAGLIO: "/linneo-fe/#/classificazione/dettaglio/",
  LINNEO_CLASSIFICA_DETTAGLIO_SERVIZI_TOSCANA:
    "/linneo/#/classificazione/dettaglio/",
  LINNEO_FE_BASE_URL: "",

  GESCOR_SUFFISSO_CREA_BOZZA: "/crea-corrispondenza",
  URL_DETTAGLIO_IPER_FASCICOLO:
    "../phylum/#/gestione-fascicoli/dettaglio-iper-fascicolo/",
  URL_DETTAGLIO_UNITA_DOC: "../phylum/#/gestione-fascicoli/dettaglio/",
  URL_GESCOR_DETTAGLIO_PARTENZA: "/documentale/corrispondenze/partenza/",
  URL_GESCOR_LISTA_PARTENZE:
    "../gestione-corrispondenza/#/partenze/lista-utente",
  URL_RICERCA_PERSONALI_GESCOR:
    "/documentale/corrispondenze/arrivo/ricercaCorrispondenzeDipendente",
  API_ORGANIGRAMMA_DIP: "/protocollo/organigramma/dipendente/",
  API_ORGANIGRAMMA_DIRIGENTE: "/protocollo/organigramma/organo/dirigente",
  URL_GESCOR_DETTAGLIO_ARRIVO: "/documentale/corrispondenze/arrivo/",
  URL_RICERCA_ATTRIBUITE_GESCOR:
    "/documentale/corrispondenze/arrivo/ricercaAttribuite/",
  URL_RICERCA_PARTENZE_GESCOR: "/documentale/corrispondenze/partenza/ricerca/",
  URL_GESCOR: "/documentale/corrispondenze/",
  URL_ANAGRAFE_DETTAGLIO_PROVVISORIO:
    "../anagrafe/soggetto/dettaglioService?id=",
  URL_API_ORGANIGRAMMA_CMU: "/protocollo/organigramma/organigrammaRicerca/",
  URL_RICERCA_ANAGRAFE_ESTESA_SSE: "/anagrafe/sse/ricercaSempliceEstesa",
  URL_RICERCA_LISTE_ANAGRAFE: "/anagrafe/listaDistribuzione/ricerca/",
  URL_RICERCA_AVANZATA_ANAGRAFE_ESTESA_SSE:
    "/anagrafe/sse/ricercaAvanzataEstesa",
  URL_RICERCA_RECAPITO: "/anagrafe/recapito/",
  URL_RICERCA_SOGGETTO: "/anagrafe-corrispondenti/soggetti/ricerca",
  URL_RICERCA_COMUNE: "/anagrafe-corrispondenti/utility/comuni/",
  URL_CREA_RECAPITO: "/anagrafe/soggetto/{id}/recapito",
  LINNEO_RICERCA_TIPOLOGIA_IPER_FASCICOLO_BY_ID:
    "/linneo/tipologie-iper-fascicolo/",
  // ente, in futuro da recuperare dall'utente
  URL_EVENTI: "/documentale/eventi/listen?app=DOC",
  URL_LINGUE: "lingue/",
  URL_AREA_CONFERIMENTO:
      "/documentale/fascicolo/area-conferimento/",
  // documentali repertori ricerca
  DOCUMENTALE_REPERTORI_RICERCA: "ricerca",
  CODICE_AOO_GRT: "AOOGRT",
  API_ANAG_CAMPI_SPECIFICI: "/campi-specifici",
  API_LISTE_VISIBILITA: "/liste-visibilita",
  URL_SOGGETTI_ESTERNI_RICERCA:
      "/soggetti-esterni/ricerca",
  API_SOGGETTI_ESTERNI: "/soggetti-esterni",
  URL_UD_AREA_CONFERIMENTO:
      "/documentale/fascicolo/ud-area/",
};
